const ONE_SEC = 1000 // ms
const ONE_MIN = 60 * ONE_SEC
const ONE_HOUR = 60 * ONE_MIN
const ONE_DAY = 24 * ONE_HOUR
const ONE_YEAR = 365 * ONE_DAY

export const TIME = {
	ONE_SEC,
	ONE_MIN,
	ONE_HOUR,
	ONE_DAY,
	ONE_YEAR
}

export const TIMEOUT_FETCH = 5 * ONE_SEC // * 3
export const TIMEOUT_FETCH_REPORT = 60 * ONE_SEC